import moment from '@/utils/moment-wrapper';
import * as highcharts from 'highcharts';
import sanitizeHTML from 'sanitize-html';
import { getKey as getSessionDataKey } from '@/data/session/session-globals';
import { i18n_locale } from '@/utils/i18n';

export const $pendo = { moment, highcharts, sanitize: sanitizeHTML };

const pendoGlobalsPlugin = {
    install: (Vue) => {
        Vue.config.globalProperties.$activeUser = getSessionDataKey('activeUser');
        Vue.config.globalProperties.$activeSubscription = getSessionDataKey('activeSubscription');
        Vue.config.globalProperties.$activeOrganization = getSessionDataKey('activeOrganization');
        Vue.config.globalProperties.$activeApplicationMap = getSessionDataKey('activeApplications');
        Vue.config.globalProperties.$normalizedLocale = () => i18n_locale.value;

        Vue.prototype.$pendo = $pendo;
    },
};

export default pendoGlobalsPlugin;
